import { commonInfo, decorateInfo } from '@/api/api'
import { userInfo } from "@/api/user"

const state = {
  loaded: false,
  openEdit: false,
  showFooter: false,
  commonInfo: {
    customService: '',
    pubKey: '',
    dtlCtg: {},
    companyInfo: {
      gray: 'N',
      honor: '100+',
      customer: '1000+',
      desc: '建信理财有限责任公司是中国建设银行的全资子公司，于2019年5月24日正式成立，并于2019年6月3日在广东省深圳市举行开业仪式，注册资本为人民币150亿元。建信理财始终坚持高质量发展方向，秉承“义利与共”的价值理念，牢记“为人民理财、服务国家建设”的初心使命，不断满足人民群众日益增长的理财需求。'
    },
    navMenus: {
      news_center: [],
      job: [],
      about_us: [],
      personal_finance: [],
      ele_bank: [],
      cor_fin: [],
      bank_card: [],
    }
  },
  decorateInfo: {
    index_top_carousel: { itemList: [] },
    index_footer_text_1: { itemList: [] },
    index_footer_text_2: { itemList: [] },
    index_footer_text_3: { itemList: [] },
    index_footer_text_4: { itemList: [] },
    index_footer_text_5: { itemList: [] },
    invest_top_banner: { title: '', link: '', url: '' },
    info_dis_top_banner: { title: '', link: '', url: '' },
    about_top_banner: { title: '', link: '', url: '' },
    product_top_banner: { title: '', link: '', url: '' },
    index_news_banner: { title: '', link: '', url: '' },
    index_top_column: { itemList: [] },
    index_news_column: { itemList: [] },
    index_bottom_column: { itemList: [] },
  },
  userInfo: {
    cstNm: '',
    crdtNo: '',
    crdtTp: '',
    mobile: '',
    flag: '0',
    lastLoginDate: '',
    lastLoginIp: ''
  }
}

const actions = {
  getUserInfo({ commit }){
    return new Promise((resolve, reject) => {
      userInfo().then(response => {
        commit('SET_USER_INFO', response.data)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCommonInfo ({ commit }) {
    return new Promise((resolve, reject) => {
      commonInfo().then(response => {
        commit('SET_COMMON_INFO', response.data)
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getDecorateInfo ({ commit }) {
    return new Promise((resolve, reject) => {
      decorateInfo().then(response => {
        commit('SET_DECORATE_INFO', response.data)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}

const mutations = {
  SET_COMMON_INFO: (state, data) => {
    let obj = Object.assign({}, state.commonInfo, data)
    state.commonInfo = obj
  },
  SET_LOADED: (state, data) => {
    state.loaded = data
  },
  SET_SHOW_FOOTER: (state, data) => {
    state.showFooter = data
  },
  SET_DECORATE_INFO: (state, data) => {
    let obj = Object.assign({}, state.decorateInfo, data)
    state.decorateInfo = obj
  },
  UPDATE_EDIT: (state, data) => {
    state.openEdit = data
  },
  SET_USER_INFO: (state, data) => {
    state.userInfo = Object.assign({}, data)
  },
}

export default {
  state,
  mutations,
  actions
}
